module.exports = __webpack_public_path__ + "static/img/stayInControlMonitor.2412968a.png";